import NextLink from 'next/link'
import { twMerge } from 'tailwind-merge'
import Image from 'next/image'

type Props = {
  className?: string
  size?: string
} & ((React.ComponentPropsWithoutRef<'div'>))

export function Logo({ className, size }: Props) {
  return (
    <div className={
      twMerge(
        'flex justify-center',
        className,
      )
    }>
      <NextLink hrefLang='en' href='/' aria-label="Go to home page">
        <Image
          width={942}
          height={186}
          src='/img/cruz-logo.svg'
          alt='Cruz.com'
          priority
          className={twMerge('block dark:hidden', size)}
        />
        <Image
          width={942}
          height={186}
          src='/img/cruz-logo-rev.svg'
          alt='Cruz.com'
          priority
          className={twMerge('hidden dark:block dark:opacity-80', size)}
        />
        {/* <img src='/img/cruz-logo.svg' className={twMerge('block dark:hidden', size)} alt='Cruz.com' /> */}
        {/* <img src='/img/cruz-logo-rev.svg' className={twMerge('hidden dark:block dark:opacity-80', size)} alt='Cruz.com' /> */}
      </NextLink>
    </div>
  )
}
